import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./intentInsights.module.scss";

export default function AutoInsightHero({ insights, multiple = false }) {
  const { t } = useTranslation();
  const items = multiple ? insights : insights?.slice(0, 1);

  if (!items?.length) return null;

  return (
    <section className={styles.autoInsightSection} aria-label="Auto insights">
      <div className={styles.autoInsightLabel}>
        {multiple
          ? t("sonic_prospect.intent_insights.auto_insights_title")
          : t("sonic_prospect.intent_insights.auto_insight_title")}
      </div>
      <div className={multiple ? styles.autoInsightStack : styles.autoInsightSingle}>
        {items.map((item) => (
          <article key={item.id} className={styles.autoInsightCard}>
            <p className={styles.autoInsightHeadline}>{item.headline}</p>
            <p className={styles.autoInsightDetail}>{item.detail}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
